import { RSAA } from 'redux-api-middleware';
import { createRsaaTypes, createHeaders } from '../actionHelpers';

import queryString from 'query-string';

export const ADMIN_FAQS_SEARCH = 'ADMIN_FAQS_SEARCH';
export const ADMIN_FAQS_SEARCH_SUCCESS = 'ADMIN_FAQS_SEARCH_SUCCESS';
export const ADMIN_FAQS_SEARCH_FAILURE = 'ADMIN_FAQS_SEARCH_FAILURE';

export const ADMIN_FAQS_SET_SEARCH_PARAMETERS = 'ADMIN_FAQS_SET_SEARCH_PARAMETERS';

export const ADMIN_FAQS_GET = 'ADMIN_FAQS_GET';
export const ADMIN_FAQS_CREATE = 'ADMIN_FAQS_CREATE';
export const ADMIN_FAQS_UPDATE = 'ADMIN_FAQS_UPDATE';
export const ADMIN_FAQS_DELETE = 'ADMIN_FAQS_DELETE';

export const searchFaqs = searchParameters => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_FAQS_SEARCH),
        endpoint: `/api/admin/faqs?${queryString.stringify(searchParameters)}`,
        headers: createHeaders(false),
        method: 'GET'
    }
});

export const getFaq = id => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_FAQS_GET),
        endpoint: `/api/admin/faqs/${id}`,
        headers: createHeaders(false),
        method: 'GET'
    }
});

export const createFaq = faq => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_FAQS_CREATE),
        endpoint: '/api/admin/faqs',
        headers: createHeaders(true),
        method: 'POST',
        body: JSON.stringify(faq)
    }
});

export const updateFaq = (id, faq) => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_FAQS_UPDATE),
        endpoint: `/api/admin/faqs/${id}`,
        headers: createHeaders(true),
        method: 'PUT',
        body: JSON.stringify(faq)
    }
});

export const deleteFaq = id => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_FAQS_DELETE),
        endpoint: `/api/admin/faqs/${id}`,
        headers: createHeaders(false),
        method: 'DELETE'
    }
});

export const setSearchParameters = searchParameters => ({
    type: ADMIN_FAQS_SET_SEARCH_PARAMETERS,
    searchParameters
});
